import React from "react";
import { useNavigate } from "react-router-dom";

interface CourseCardProps {
  title: string;
  image: string;
  description: string;
  duration: string;
}

const CourseCard: React.FC<CourseCardProps> = ({
  title,
  image,
  description,
  duration,
}) => {
  const navigate = useNavigate();
  const handleBook = () => {
    navigate("/contactus");
  };

  return (
    <div className="border rounded-lg shadow-lg overflow-hidden max-w-sm bg-white hover:scale-105 transition-transform duration-200 flex flex-col">
      <img src={image} alt={title} className="w-full h-48 object-cover" />
      <div className="p-4 flex flex-col flex-1">
        <h2 className="text-xl font-bold text-gray-800 mb-2 max-w-[300px]">
          {title}
        </h2>
        <p className="text-gray-600 mb-4 max-w-[300px]">{description}</p>
        <p className="text-sm text-gray-500 mb-4">
          <strong>Duration:</strong> {duration} <br />
        </p>
        <button
          className="mt-auto w-full py-2 px-4 bg-red-600 text-white rounded-md hover:bg-red-700 transition"
          onClick={handleBook}
        >
          Book Now
        </button>
      </div>
    </div>
  );
};

export default CourseCard;
